import Button from '../base/Button';
import { useAppConfig } from '../../hooks/useAppConfig';

export default function Hero() {
  const appConfig = useAppConfig();
  
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(135deg, ${appConfig.gradientFrom} 0%, ${appConfig.gradientTo} 100%), url('${appConfig.heroBackgroundImage}')`
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              {appConfig.tagline.split(' ').map((word, index) => {
                // Highlight only "4K" and "HD" words
                const isHighlight = word === '4K' || word === 'HD';
                return isHighlight ? (
                  <span key={index} className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">
                    {word}{' '}
                  </span>
                ) : (
                  <span key={index}>{word} </span>
                );
              })}
            </h2>
            <p className="text-lg sm:text-xl text-white/90 mb-6 sm:mb-8 leading-relaxed">
              {appConfig.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6 sm:mb-8">
              <Button size="lg" href="#download" className="flex items-center justify-center space-x-3 w-full sm:w-auto">
                <i className="ri-download-line text-xl"></i>
                <span>Download Free</span>
              </Button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6 text-white/80">
              <div className="flex items-center space-x-2">
                <i className="ri-star-fill text-yellow-400"></i>
                <span className="font-semibold">{appConfig.rating}</span>
                <span>Rating</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-download-cloud-line"></i>
                <span className="font-semibold">{appConfig.downloads}</span>
                <span>Downloads</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-image-line"></i>
                <span className="font-semibold">{appConfig.totalWallpapers}</span>
                <span>Wallpapers</span>
              </div>
            </div>
          </div>
          
          <div className="relative order-1 lg:order-2">
            <div className="flex justify-center items-center space-x-4 sm:space-x-8">
              {/* iPhone Mockup */}
              <div className="relative transform rotate-6 sm:rotate-12 hover:rotate-3 sm:hover:rotate-6 transition-transform duration-500">
                <div className="w-32 h-64 sm:w-48 sm:h-96 lg:w-64 lg:h-[520px] bg-black rounded-2xl sm:rounded-[3rem] p-1 sm:p-2 shadow-2xl">
                  <div className="w-full h-full bg-white rounded-xl sm:rounded-[2.5rem] overflow-hidden relative">
                    <img 
                      src={appConfig.heroImages.iphone}
                      alt={`${appConfig.name} on iPhone`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-2 sm:top-4 left-1/2 transform -translate-x-1/2 w-8 h-2 sm:w-20 sm:h-6 bg-black rounded-full"></div>
                  </div>
                </div>
              </div>
              
              {/* Android Mockup */}
              <div className="relative transform -rotate-6 sm:-rotate-12 hover:-rotate-3 sm:hover:-rotate-6 transition-transform duration-500">
                <div className="w-32 h-64 sm:w-48 sm:h-96 lg:w-64 lg:h-[520px] bg-gray-900 rounded-xl sm:rounded-[2rem] p-1 sm:p-2 shadow-2xl">
                  <div className="w-full h-full bg-white rounded-lg sm:rounded-[1.5rem] overflow-hidden relative">
                    <img 
                      src={appConfig.heroImages.android}
                      alt={`${appConfig.name} on Android`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-5 -left-5 sm:-top-10 sm:-left-10 w-10 h-10 sm:w-20 sm:h-20 bg-white/10 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-5 -right-5 sm:-bottom-10 sm:-right-10 w-16 h-16 sm:w-32 sm:h-32 bg-purple-500/20 rounded-full blur-xl animate-pulse delay-1000"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
